import { State } from 'store';
import getSelectedWorkflowDefinitionDetails from './getSelectedWorkflowDefinitionDetails';

export default function getFilesSchema(state: State) {
  const details = getSelectedWorkflowDefinitionDetails(state);
  return details && details.files_schema.in;
}
